// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetSafetyHookListRequestModel from '../../model/get-safety-hook-list-request-model';
import GetSafetyHookLookupRequestModel from '../../model/get-safety-hook-lookup-request-model';
import GetSafetyHookByIdRequestModel from '../../model/get-safety-hook-by-id-request-model';
import SafetyHookListResultModel from '../../model/safety-hook-list-result-model';
import Int64LookupListResultModel from '../../model/int64-lookup-list-result-model';
import SafetyHookModel from '../../model/safety-hook-model';

export default (service: Servicelayer) => ({
  /**  */
  async getSafetyHookList(request: GetSafetyHookListRequestModel, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-safety-hook-list'] ?? 'siha/SiHaSafetyHook';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(SafetyHookListResultModel.toModel(dto));
  },
  /**  */
  async getSafetyHookLookup(request: GetSafetyHookLookupRequestModel, config?: RequestConfig) {
    const requestDTO = GetSafetyHookLookupRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-safety-hook-lookup'] ?? 'siha/SiHaSafetyHook/Lookup';
    const response = await service.get<any>(endpointPath, {
      query: {
        canFastenOnCounterbatten: requestDTO.canFastenOnCounterbatten,
        groupName: requestDTO.groupName,
        safetyHookType: requestDTO.safetyHookType,
        standardScrewThickness: requestDTO.standardScrewThickness,
        standardScrewLength: requestDTO.standardScrewLength,
        counterbattenScrewLength: requestDTO.counterbattenScrewLength,
        minimumScrewDepth: requestDTO.minimumScrewDepth,
        siHaDocumentationId: requestDTO.siHaDocumentationId,
        screwType: requestDTO.screwType,
        screwConnectionMustBeDocumented: requestDTO.screwConnectionMustBeDocumented,
        id: requestDTO.id,
        key: requestDTO.key,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Int64LookupListResultModel.toModel(dto));
  },
  /**  */
  async getSafetyHookById(request: GetSafetyHookByIdRequestModel, config?: RequestConfig) {
    const requestDTO = GetSafetyHookByIdRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-safety-hook-by-id'] ?? 'siha/SiHaSafetyHook/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(SafetyHookModel.toModel(dto));
  },
});
